import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { Department, DepartmentControllerApi } from "../services";
import { Identified } from "../types/sdk-types";
import {
  DGT_Pagination,
  asPaginatedContent,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../utils/utils";

interface UseDepartmentListProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  searchKey?: string;
  providerGroupId?: string | null;
  locationUuid?: string;
  status?: boolean;
}

/**
 *
 * @author Shrinivas Mandhare
 */

export function useDepartmentList({
  gridSorting,
  pagination,
  searchKey,
  providerGroupId,
  locationUuid,
  status,
}: UseDepartmentListProps): useBaseContent<Identified<Department>> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;

  return useQuery({
    queryKey: [
      "provider-group-departments-list",
      pageSize,
      pageIndex,
      providerGroupId,
      searchKey,
      gridSorting,
      locationUuid,
    ],
    enabled:
      providerGroupId !== undefined &&
      providerGroupId !== null &&
      providerGroupId !== "0",
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new DepartmentControllerApi(getConfigObject())
        .getAllDepartments2(
          pageIndex, //page
          pageSize, //size
          sortBy, // sortBy
          sortDirect, // sortDirection
          status, //status
          false, //archive
          locationUuid, //locationUuid
          searchKey, //searchString
          providerGroupId! //xTENANTID
        )
        .then((res) => asPaginatedContent<Identified<Department>>(res?.data)),
  });
}
